import React from "react";
import { Helmet } from "react-helmet";
import { useIntl } from "gatsby-plugin-react-intl";

import defaultImage from "../../static/images/axur-seguranca-cibernetica.jpg";

function Seo({ description, title, metaImage, urlPage, robotsPage }) {
  const intl = useIntl();

  const lang = intl.formatMessage({ id: "lang" });
  const tagLine = intl.formatMessage({ id: "tagline" });
  const plataforma = intl.formatMessage({ id: "plataforma_axur" });
  const pageTitle = title ? `${title} | ${plataforma}` : `${tagLine}`;
  const image = metaImage ? metaImage : defaultImage;
  const url = urlPage ? urlPage : "";
  const robots = robotsPage ? robotsPage : "index, follow";

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: lang,
        }}
      >
        {/* Cache control */}
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content={new Date()} />

        {/* SEO */}
        <meta name="robots" content={robots} />
        <link
          rel="canonical"
          href={`https://start.axur.com/${intl.locale}/${url}/`}
        />
        <link
          rel="alternate"
          hrefLang="pt-BR"
          href={`https://start.axur.com/pt-br/`}
        />
        <link
          rel="alternate"
          hrefLang="en-US"
          href={`https://start.axur.com/en-us/`}
        />
        <link
          rel="alternate"
          hrefLang="es"
          href={`https://start.axur.com/es-es/`}
        />

        {/* Author */}
        <meta name="author" content={tagLine} />
        <meta name="copyright" content={tagLine} />

        {/* General tags */}
        <title>{pageTitle}</title>
        <meta name="description" content={description} />
        <meta name="image" content={image} />

        {/* OpenGraph tags */}
        <meta
          property="og:locale"
          content={intl.formatMessage({ id: "og_locale" })}
        />
        <meta
          property="og:url"
          content={`https://start.axur.com/${intl.locale}/${url}`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:image" itemprop="image" content={image} />
        <meta property="og:image:secure_url" itemprop="image" content={image} />
        <link itemprop="thumbnailUrl" href={image} />
        <meta property="og:image:alt" content={pageTitle} />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="800" />
        <meta property="og:image:height" content="600" />
        {/* <meta property="fb:app_id" content="" /> */}

        {/* Twitter Card tags */}
        <meta name="twitter:creator" content="@AxurBrasil" />
        <meta name="twitter:site" content={pageTitle} />
        <meta property="twitter:image" content={image} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content={`https://start.axur.com/${intl.locale}/${url}`}
        />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={description} />
      </Helmet>
    </>
  );
}

export default Seo;
